module.exports = __webpack_public_path__ + "img/icon-grid-2.781f2ab5.svg";